export default {
  DROPDOWN_LINK_LABEL: 'Add to my calendar',
  GOOGLE_LINK_LABEL: 'Google (online)',
  OFFICE365_LINK_LABEL: 'Office 365 (online)',
  YAHOO_LINK_LABEL: 'Yahoo (online)',
  APPLE_LINK_LABEL: 'Apple',
  OUTLOOK_LINK_LABEL: 'Outlook',
  ICS_LINK_LABEL: 'Other (download ICS file)'
};